jQuery(document).ready(function($) {
  'use strict';
  var openclass = 'open',
  firstHarmonicaItem = $('.firstHarmonicaItemOpen').find('.hrm__item').first();

  if ($('.harmonica:not(.editmode)').length) {
    if ($('.harmonica:not(.editmode) .hrm__item').length) {
      $('.harmonica:not(.editmode) .hrmi__title').on('click', function() {
        var harmonicaitem = $(this).parent(),
            collapsablecontent = $(harmonicaitem).find('.collapsablecontent'),
            harmonicacontent = $(collapsablecontent).find('.harmonicacontent');

        if ($(harmonicaitem).hasClass('collapsablecontent')) {
          return;
        }

        $('.hrm__item.open .collapsablecontent').removeAttr('style');
        if ($(harmonicaitem).hasClass(openclass)) {
          $('.hrm__item').removeClass(openclass);
        } else {
          $('.hrm__item').removeClass(openclass);
          $(harmonicaitem).addClass(openclass);
          if (isNaN($($($(this).parent()).find('.introtekst')).outerHeight(true))) {
            $(collapsablecontent).css('max-height', $(harmonicacontent).outerHeight(true));
          } else {
            $(collapsablecontent).css('max-height', $(harmonicacontent).outerHeight(true) + $($($(this).parent()).find('.introtekst')).outerHeight(true));
          }
        }
      });

      // open initieel het eerste panel
      $(firstHarmonicaItem).addClass(openclass);
      if ($(firstHarmonicaItem).find('.titel').length > 0) {
        $(firstHarmonicaItem).find('.collapsablecontent').css('max-height', $(firstHarmonicaItem).find('.harmonicacontent').outerHeight(true) + $(firstHarmonicaItem).find('.titel').outerHeight(true));
      } else {
        // $('.harmonica:not(.editmode) .harmonicaitem:first-child .collapsablecontent').css('max-height', $('.harmonicaitem:first-child .harmonicacontent').outerHeight(true));
        // $(firstHarmonicaItem).find('.collapsablecontent').css('max-height', $(firstHarmonicaItem).find('.harmonicacontent').outerHeight(true));
      }
    }
  } else {
    $('.harmonica.editmode .hrm__item').each(function() {
      $(this).addClass(openclass);
      $(this).find('.collapsablecontent').css('max-height', $(this).find('.harmonicacontent').outerHeight(true));
    });
  }
});
